import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CashAccountTransactionsSingleReport  {
    _originalTypeClassName = "zERP.BO.CashAccountTransactionsSingleReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CashAccountTransactionsSingleReport.translate = translateService;
}
this.Date = null;
this.Invoice = null;
this.Description = null;
this.Charge = null;
this.Credit = null;
this.Balance = null;
this.CumulativeCharge = null;
this.CumulativeCredit = null;
this.Remaining = null;
this.GroupBy = null;
this.CashAccountTransactionsSingleReportKey = null;
this._key = this.CashAccountTransactionsSingleReportKey = 0; 
}

static translate: TranslateService;
_key: any;
Date:any;
Invoice:any;
Description:any;
Charge:any;
Credit:any;
Balance:any;
CumulativeCharge:any;
CumulativeCredit:any;
Remaining:any;
GroupBy:any;
private _CashAccountTransactionsSingleReportKey:any;
get CashAccountTransactionsSingleReportKey(): any {
    return this._CashAccountTransactionsSingleReportKey;
  }
set CashAccountTransactionsSingleReportKey(value: any) {
    this._CashAccountTransactionsSingleReportKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CashAccountTransactionsSingleReportKey == null || $this.CashAccountTransactionsSingleReportKey == 0;
            }


}